import { h } from 'preact'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import PageTimer from '../../PageTimer'
import { transactionDetailsSelector } from '../../../redux/slice/transactionDetailsSlice'

const PaymentTimer = ({ showHoursInTimer }) => {
  const { expiryDate, timeoutUrl } = useSelector(transactionDetailsSelector)

  return (
    <PageTimer
      expiryDate={expiryDate}
      timeoutUrl={timeoutUrl}
      showHoursInTimer={showHoursInTimer}
    />
  )
}

PaymentTimer.propTypes = {
  showHoursInTimer: PropTypes.string,
}

export default PaymentTimer
